<template>
  <b-container>
    <b-modal
      ref="openModal"
      class="localizationModal"
      scrollable
      size="lg"
      :title="`${processName} #${fillingDetailsId}`"
      @hidden="handleHide"
    >
      <div v-if="isViewing">
        <b-row class="mb-4">
          <a
            v-if="canViewMap"
            title="Localização"
            class="card-buttons"
            v-b-tooltip.hover
            @click="isViewingMap = !isViewingMap"
          >
            <b-button size="sm" class="ml-2 mb-0 mt-0 pb-2">
              <i class="tim-icons icon-square-pin"></i>
            </b-button>
          </a>
          <a
            title="Editar"
            v-if="permissions.simpleOperate == false"
            class="card-buttons"
            v-b-tooltip.hover
            @click="isEditing = !isEditing"
          >
            <b-button size="sm" class="ml-2 mb-0 mt-0 pb-2">
              <i class="tim-icons icon-pencil"></i>
            </b-button>
          </a>
          <a
            title="Próxima etapa"
            class="card-buttons"
            v-b-tooltip.hover
            @click="isNextStaging = !isNextStaging"
          >
            <b-button size="sm" class="ml-2 mb-0 mt-0 pb-2">
              <i class="tim-icons icon-double-right"></i>
            </b-button>
          </a>
          <a
            title="Comentários"
            class="card-buttons"
            v-b-tooltip.hover
            @click="isCommenting = !isCommenting"
          >
            <b-button size="sm" class="ml-2 mb-0 mt-0 pb-2">
              <i class="tim-icons icon-notes"></i>
            </b-button>
          </a>
          <!-- Botões de ativação -->
          <a
            title="Inativar"
            class="card-buttons"
            v-if="permissions.simpleOperate == false"
            v-b-tooltip.hover
            @click="$refs.confirmInactivation.show()"
          >
            <b-button
              v-if="model.active == 'Sim'"
              variant="danger"
              title="Inativar card"
              class="ml-2 mb-0 mt-0 pb-2"
              size="sm"
              :disabled="isSubmitting"
            >
              <i class="tim-icons icon-simple-remove"></i>
            </b-button>
          </a>
          <a
            title="ativar"
            class="card-buttons"
            v-b-tooltip.hover
            @click="$refs.confirmActivation.show()"
          >
            <b-button
              v-if="model.active == 'Não'"
              variant="green"
              title="Ativar card"
              class="ml-2 mb-0 mt-0 pb-2"
              size="sm"
              :disabled="isSubmitting"
            >
              <i class="tim-icons icon-simple-add"></i>
            </b-button>
          </a>
        </b-row>

        <base-dialog-yes-or-no
          ref="confirmInactivation"
          @yes="disableProcess"
          :message="'Tem certeza que deseja inativar o card?'"
          :title="''"
        >
        </base-dialog-yes-or-no>

        <base-dialog-yes-or-no
          ref="confirmActivation"
          @yes="activeProcess"
          :message="'Tem certeza que deseja ativar o card?'"
          :title="''"
        >
        </base-dialog-yes-or-no>

        <div v-if="isLoadingFields">
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>{{ $t("geral.loadingData") }}</strong>
          </div>
        </div>

        <!-- campos de resumo -->
        <filling-details-summary-fields :fields="summaryFields">
        </filling-details-summary-fields>
      </div>
      <div v-else-if="isViewingMap">
        <workflow-map
          ref="workflowMap"
          :latitude="model.lastStatusLatitude"
          :longitude="model.lastStatusLongitude"
        >
        </workflow-map>
      </div>
      <div v-else-if="isCommenting">
        <filling-details-comment
          ref="comment"
          :process-filled-id="fillingDetailsId"
          :stage-id="fillingStageId"
          :can-comment="canComment"
        >
        </filling-details-comment>
      </div>
      <div v-else-if="isEditing">
        <filling-details-edit
          ref="edit"
          :process-filled-id="fillingDetailsId"
          :readonly="false"
          :is-submitting.sync="isSubmitting"
          @refreshData="confirmOperationFinish()"
        >
        </filling-details-edit>
      </div>
      <div v-else-if="isNextStaging">
        <filling-details-next-stage
          ref="nextStage"
          :process-filled-id="fillingDetailsId"
          :is-submitting.sync="isSubmitting"
          @refreshData="confirmOperationFinish()"
        >
        </filling-details-next-stage>
      </div>

      <template #modal-footer>
        <div class="right">
          <b-button
            v-if="!isViewing && !isViewingMap && !isCommenting && !isSubmitting"
            :disabled="isSubmitting"
            variant="green"
            @click="confirmOperation()"
          >
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button
            v-else-if="
              !isViewing && !isViewingMap && !isCommenting && isSubmitting
            "
            :disabled="isSubmitting"
            variant="green"
          >
            <b-row>
              <b-col cols="0" class="ml-3 mr-1">
                <strong>{{ $t("geral.savingData") }}</strong>
              </b-col>
              <b-col cols="0" class="mr-3">
                <clip-loader
                  :loading="true"
                  :color="'white'"
                  :size="'14px'"
                ></clip-loader>
              </b-col>
            </b-row>
          </b-button>

          <b-button
            v-if="!isViewing && !isEditing && !isNextStaging"
            class="ml-2"
            variant="danger"
            @click="cancelOperation()"
          >
            {{ $t("geral.back") }}
          </b-button>
          <b-button
            v-if="!isViewing && !isViewingMap && !isCommenting"
            class="ml-2"
            variant="danger"
            @click="cancelOperation()"
          >
            {{ $t("geral.cancel") }}
          </b-button>
          <b-button class="ml-2" variant="warning" @click="closeModal()">
            {{ $t("geral.close") }}
          </b-button>
        </div>
      </template>
      <!-- <pre class="language-json"><code>Model: {{ permissions  }}</code></pre> -->
      <!-- <pre class="language-json"><code>Model: {{ model  }}</code></pre> -->
      <!-- <pre class="language-json"><code>FillingDetails: {{ summaryFields  }}</code></pre> -->
    </b-modal>
  </b-container>
</template>

<script>
export default {
  name: "FillingDetailsModal",
  props: {
    processName: String,
    permissions: Object,
  },
  components: {
    // "base-row-detail": () => import("@/components_rms/base/BaseRowDetail.vue"),
    "base-dialog-yes-or-no": () =>
      import("@/components_rms/base/BaseDialogYesOrNo.vue"),
    // "base-dialog-confirm": () => import("@/components_rms/base/BaseDialogConfirm.vue"),
    "clip-loader": () => import("vue-spinner/src/ClipLoader.vue"),
    "filling-details-comment": () =>
      import(
        "@/components_rms/workflow/WorkflowFilled/FillingDetails/FillingDetailsComment.vue"
      ),
    "filling-details-edit": () =>
      import(
        "@/components_rms/workflow/WorkflowFilled/FillingDetails/FillingDetailsEdit.vue"
      ),
    "filling-details-next-stage": () =>
      import(
        "@/components_rms/workflow/WorkflowFilled/FillingDetails/FillingDetailsNextStage.vue"
      ),
    "filling-details-summary-fields": () =>
      import(
        "@/components_rms/workflow/WorkflowFilled/FillingDetails/FillingDetailsSummaryFields.vue"
      ),
    "workflow-map": () => import("@/components_rms/workflow/WorkflowMap.vue"),
  },
  data() {
    return {
      canComment: false,
      summaryFields: [],
      model: {},
      fillingDetailsId: 0,
      fillingStageId: 0,
      isCommenting: false,
      isEditing: false,
      isLoadingFields: true,
      isNextStaging: false,
      isSubmitting: false,
      isViewingMap: false,
    };
  },
  computed: {
    canViewMap() {
      if (!this.permissions) return false;
      if (this.permissions == null) return false;
      if (this.permissions.advancedOperate) return true;
      if (this.permissions.administrador) return true;
      if (this.permissions.gestor) return true;
      return false;
    },
    isViewing() {
      if (this.isCommenting) return false;
      if (this.isEditing) return false;
      if (this.isNextStaging) return false;
      if (this.isViewingMap) return false;
      return true;
    },
  },
  methods: {
    cancelOperation() {
      this.isCommenting = false;
      this.isEditing = false;
      this.isNextStaging = false;
      this.isViewingMap = false;
    },
    closeModal() {
      this.cancelOperation();
      this.$refs.openModal.hide();
    },
    confirmHide() {
      this.isShowing = false;
      this.$refs.openModal.hide();
    },
    confirmOperation() {
      try {
        if (this.isSubmitting == true) {
          return;
        }
        this.isSubmitting = true;
        if (this.isEditing) {
          this.$refs.edit.save();
        }
        if (this.isNextStaging) {
          this.$refs.nextStage.save();
        }
      } catch (error) {
        this.isSubmitting = false;
      }
    },
    async confirmOperationFinish() {
      this.isSubmitting = false;
      this.cancelOperation();
      this.$refs.openModal.hide();
      this.$emit("refreshData");
    },
    activeProcess() {
      this.isSubmitting = true;
      this.$apiWorkflow
        .post("/processFilled/active/" + this.model.id)
        .then((response) => {
          this.isSubmitting = false;
          this.model.active = "Sim";
          this.$emit("refreshData");
          this.$refs.openModal.hide();
          // this.refreshData();
          // this.hideModal();
          this.$forceUpdate;
        });
    },
    disableProcess() {
      this.isSubmitting = true;
      this.$apiWorkflow
        .post("/processFilled/disable/" + this.model.id)
        .then((response) => {
          this.isSubmitting = false;
          this.model.active = "Não";
          // this.isShowing = false;
          // this.refreshData();
          // this.hideModal();
          this.$emit("refreshData");
          this.$refs.openModal.hide();
          this.$forceUpdate;
        });
    },
    show(filledId, stageId, canComment) {
      // console.log(filledId);
      this.canComment = canComment;
      this.fillingDetailsId = filledId;
      this.fillingStageId = stageId;
      this.getDetails(filledId);
      this.loadData(filledId);
      this.$refs.openModal.show();
    },
    getDetails(id) {
      this.isLoadingFields = true;
      this.$apiWorkflow
        .get(`/v2/filled/process/summaryFields?filledId=${id}`)
        .then((response) => {
          this.summaryFields = response.data;
          this.isLoadingFields = false;
          this.$forceUpdate();
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            if (error.response.data) {
              console.log(error.response.data.errors);
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              }
            }
          }
          this.isLoadingFields = false;
          this.$forceUpdate();
        });
    },
    loadData(id) {
      this.$apiWorkflow
        .get("/filled/detail/" + id)
        .then((response) => {
          // console.log(response.data)
          this.model = response.data;
          this.$forceUpdate();
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            if (error.response.data) {
              console.log(error.response.data.errors);
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              }
            }
          }
          this.$forceUpdate();
        });
    },
    handleHide() {
      this.summaryFields = [];
      this.model = {};
      this.fillingDetailsId = 0;
      this.fillingStageId = 0;
      this.cancelOperation();
    },
  },
};
</script>

<style scoped>
.right {
  text-align: right;
  width: 100%;
}
</style>